import { ADSS_ADVANCED_MD_CONFIG } from "@/configuration/groups/adss/advancedmd";
import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { Tenancy } from "@/src/lib/tenancy";
import type { Group } from "@/src/models/group";

export type AdvancedMdConfig = Readonly<{
  officeKey: string;
  appName: string;
  selfPayFinancialClassCode?: string;
  defaultProfileId?: string;
  homeOnlyPhoneAsMobile?: boolean;
  /** Reason on the self-referral AdvancedMD adds to each chart; visits needing no authorization book under it. */
  selfReferralReason?: string;
}>;

export function getAdvancedMdConfig(group: Group): AdvancedMdConfig | null {
  return group.tenancy === Tenancy.LIVE && getGroupConfigSubdomain(group) === ConfigSubdomain.ADSS
    ? ADSS_ADVANCED_MD_CONFIG
    : null;
}
